/* eslint-disable no-alert */
import { FunctionComponent } from 'react'
import { useNavigate } from 'react-router-dom'
import Paper from '@mui/material/Paper'
import {
  Box,
  Divider,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material'
import Button from '@mui/material/Button'
import { useFormik } from 'formik'
import { loadStripe, Stripe } from '@stripe/stripe-js'

import axios from 'src/utilities/http-client'
import theme from 'src/theme'
import TermsAndConditions from 'src/user/components/terms-and-conditions'
import validationSchema from './validators/register.validators'

let stripePromise: Promise<Stripe | null>
const getStripe = () => {
  if (!stripePromise) {
    // eslint-disable-next-line fp/no-mutation
    stripePromise = loadStripe(
      import.meta.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY!,
    )
  }
  return stripePromise
}

let BoundTreeRegister: FunctionComponent = () => {
  let isTablet = useMediaQuery(theme.breakpoints.down('md'))
  let isPhone = useMediaQuery(theme.breakpoints.down('sm'))

  let navigate = useNavigate()
  let form = useFormik({
    validationSchema,
    initialValues: {
      email: '',
    },
    onSubmit: async (values) => {
      let checkoutSession = await axios
        .post('/api/register-with-boundtree', {
          email: values.email.trim(),
          accessLevel: 'boundTreeFull',
        })
        .then(() => {
          window.alert(
            'Submission successful! Please check your email to complete your registration.',
          )
          navigate(
            `/subscribe-boundtree?email=${values.email.toLowerCase().trim()}`,
          )
        })
        .catch(() => window.alert('Email already exists.'))

      if ((checkoutSession as any)?.data.bypassCheckout) {
        return navigate('/self-paced')
      }

      if ((checkoutSession as any).statusCode === 500) {
        return window.alert((checkoutSession as any)?.message)
      }

      // Redirect to Checkout.
      let stripe = await getStripe()
      let { error } = await (stripe as any).redirectToCheckout({
        // Make the id field from the Checkout Session creation API response
        // available to this file, so you can provide it as parameter here
        // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
        sessionId: (checkoutSession as any)?.data.id,
      })
      // If `redirectToCheckout` fails due to a browser or network
      // error, display the localized error message to your customer
      // using `error.message`.

      return window.alert(error.message)
    },
  })

  return (
    <Box
      component="main"
      className="relative h-screen"
      style={{
        background:
          'linear-gradient(to left, rgba(66, 165, 245,0.4), rgba(66, 165, 245,0)) 55%, url(/banner.png)',
        backgroundSize: '25% 100%, cover',
        backgroundPosition: 'right center, center center',
        backgroundRepeat: 'no-repeat, no-repeat',
        marginTop: -60,
      }}
    >
      <Box className="flex justify-center mt-5" style={{ paddingTop: 60 }}>
        <Typography
          component="h1"
          sx={{ fontFamily: 'smileAndWave' }}
          variant="h4"
        >
          Let's get started!
        </Typography>
      </Box>
      <Box className="mx-5">
        <Box className="flex flex-row">
          <Box className="hidden md:flex">
            <Box
              className="relative flex w-2/5 justify-center"
              style={{
                background: 'url(/btlogo.png)',
                backgroundPosition: '0px 48%',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
              }}
            />
          </Box>

          <Paper
            className={`m-4 p-4 ${
              isTablet ? `${isPhone ? 'w-full' : 'w-3/4'} mx-auto` : 'w-1/2'
            }`}
          >
            <Typography>
              Please register for a FOAMfrat Studio account to use our app and
              access your certificates and profile. If you are not already a
              subscriber to our content you will be directed to a checkout page
              to purchase a subscription after registering.
            </Typography>
            <form onSubmit={form.handleSubmit}>
              <Box className={`flex ${isPhone ? 'flex-col' : 'flex-row'}`}>
                <TextField
                  fullWidth
                  variant="standard"
                  className="mx-2"
                  label="Email"
                  name="email"
                  type="text"
                  onChange={form.handleChange}
                  error={form.touched.email && !!form.errors.email}
                  helperText={form.touched.email && form.errors.email}
                />
              </Box>

              <Box className="flex justify-end">
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  className="my-6 mr-6"
                >
                  Submit
                </Button>
              </Box>
            </form>
            <Divider className="my-4" />
            <TermsAndConditions isBoundTree />
          </Paper>
        </Box>
      </Box>
    </Box>
  )
}

export default BoundTreeRegister
